import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';

import { exportsApi } from '../api/exports-api';

import { jobKeys } from './job-keys';

export function exportJobsQueryOptions(storeId: string, params: ListParams) {
  return queryOptions({
    queryKey: jobKeys.exportList(storeId, params),
    queryFn: () => exportsApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useExportJobs(storeId: string, params: ListParams) {
  return useQuery(exportJobsQueryOptions(storeId, params));
}
